import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Playfair_Display\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-playfair-display\"}],\"variableName\":\"playfair\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/dist/index.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/vercel/path0/packages/ui/src/nav/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebSocketCleanup"] */ "/vercel/path0/packages/ui/src/websocketcleanup.tsx");
